import ErrorMessage from './ErrorMessage'

export default ErrorMessage
// eslint-disable-next-line import/export
export * from './ErrorMessage'
